import { QUESTIONARE_ACTIONS } from "constants";

export function fetchQuestionare() {
    return {
        type: QUESTIONARE_ACTIONS.FETCH_QUESTIONARE
    };
}

export function fetchedQuestionare(data) {
    return {
        type: QUESTIONARE_ACTIONS.FETCHED_QUESTIONARE,
        payload: {
            data
        }
    };
}

export function failedFetchQuestionare(error) {
    return {
        type: QUESTIONARE_ACTIONS.FAILED_FETCH_QUESTIONARE,
        payload: {
            error
        }
    };
}

export function fetchAnswers(caseId) {
    return {
        type: QUESTIONARE_ACTIONS.FETCH_ANSWERS_FOR_QUESTIONARE,
        payload: {
            caseId
        }
    };
}

export function fetchedAnswers(caseId, data) {
    return {
        type: QUESTIONARE_ACTIONS.FETCHED_ANSWERS_FOR_QUESTIONARE,
        payload: {
            caseId,
            data
        }
    };
}

export function failedFetchAnswers(caseId, error) {
    return {
        type: QUESTIONARE_ACTIONS.FAILED_FETCH_ANSWERS_FOR_QUESTIONARE,
        payload: {
            caseId,
            error
        }
    };
}

export function updateAnswersForQuestionare(caseId, data) {
    return {
        type: QUESTIONARE_ACTIONS.UPDATE_QUESTIONARE_ANSWER,
        payload: {
            caseId,
            data
        }
    };
}

export function updatedAnswersForQuestionare(caseId, data) {
    return {
        type: QUESTIONARE_ACTIONS.UPDATED_QUESTIONARE_ANSWER,
        payload: {
            caseId,
            data
        }
    };
}

export function failedUpdateAnswersForQuestionare(caseId, error) {
    return {
        type: QUESTIONARE_ACTIONS.FAILED_UPDATE_QUESTIONARE_ANSWER,
        payload: {
            caseId,
            error
        }
    };
}
